module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05122400","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AjaxForm.vue
// module id = FgSE
// module chunks = 1